module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Robert ‘Lee’ Leffert, Warren Fuller and Connor Dotson provided details for several of the stories included within this ‘TINS’ collection. Richard ‘Tricky’ Cross, First Cav Loach Driver and recipient of the Silver Medal, provided careful proofreading. Robert McNaughton and Warren Fuller provided proofreading services and wordsmithing.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d4330b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Ackn.vue
// module id = 75
// module chunks = 0